<template>
  <div class="bg-white container mx-auto px-4 sm:px-6 lg:px-8 mb-10">
    <RouterView :student="student" :currentUser="currentUser"></RouterView>
    <portal to="mobile-header">
      <div class="flex-grow min-w-0 flex flex-col align-center items-center justify-center h-12">
        <div class="align-center text-lg font-bold px-1 font-display inline-flex sm:hidden text-center truncate">
            {{student.first}} {{student.last}}
        </div>
      </div>
    </portal>
    <portal to="mobile-dropdown">
      <Toggle v-slot="{ toggle, didToggle, didToggleOff }">
        <div class="relative inline-block text-left">
          <div>
            <button
              @click="didToggle"
              v-click-outside="didToggleOff"
              class="-ml-0.5 -mt-0.5 h-12 w-12 inline-flex items-center justify-center rounded-md text-gray-500 hover:text-gray-900 focus:outline-none focus:bg-cool-gray-200 transition ease-in-out duration-150" aria-label="Options" id="options-menu" aria-haspopup="true" aria-expanded="true"
            >
              <svg class="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
                <use href="/images/regular.svg#ellipsis-v"></use>
              </svg>
            </button>
          </div>


          <Transition
          enter-active-class="transition ease-out duration-100 transform"
          enter-class="opacity-0 scale-95"
          enter-to-class="opacity-100 scale-100"
          leave-active-class="transition ease-in duration-75 transform"
          leave-class="opacity-100 scale-100"
          leave-to-class="opacity-0 scale-95">
            <div v-show="toggle" class="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow border border-cool-gray-200">
              <div class="rounded-md bg-white shadow-xl">
                <div class="py-1" role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
                  <router-link :to="{name: 'studentEdit'}" class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900" role="menuitem">
                    Edit
                  </router-link>
                  <router-link :to="{name: 'studentDelete'}" class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900" role="menuitem">
                    Delete
                  </router-link>
                </div>
              </div>
            </div>
          </Transition>
        </div>
      </Toggle>
    </portal>


    <header class="hidden sm:block py-10">
      <div class="md:flex md:items-center md:justify-between max-w-7xl mx-auto">
        <div class="flex-1 min-w-0">
          <h2 class="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:leading-9 sm:truncate">
            {{student.first}} {{student.last}}
          </h2>

        </div>

        <div class="mt-4 flex md:mt-0 md:ml-4">
          <Toggle v-slot="{ toggle, didToggle, didToggleOff }">
            <span class="relative z-10 inline-flex shadow-sm rounded-md">
              <router-link :to="{ name: 'studentEdit'}" tag="button" type="button" class="relative inline-flex items-center px-4 py-2 rounded-l-md border border-gray-300 bg-white text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:z-10 focus:outline-none focus:border-blue-300 focus:ring-blue active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150">
                Edit
              </router-link>
              <span class="-ml-px relative block">
                  <button
                    @click="didToggle"
                    v-click-outside="didToggleOff"
                    type="button" class="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm leading-5 font-medium text-gray-500 hover:text-gray-400 focus:z-10 focus:outline-none focus:border-blue-300 focus:ring-blue active:bg-gray-100 active:text-gray-500 transition ease-in-out duration-150" aria-label="Expand">
                    <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                      <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                  </button>
                  <Transition
                  enter-active-class="transition ease-out duration-100 transform"
                  enter-class="opacity-0 scale-95"
                  enter-to-class="opacity-100 scale-100"
                  leave-active-class="transition ease-in duration-75 transform"
                  leave-class="opacity-100 scale-100"
                  leave-to-class="opacity-0 scale-95">
                    <div v-show="toggle" class="origin-top-right absolute right-0 mt-2 -mr-1 w-56 rounded-md shadow-lg">
                      <div class="rounded-md bg-white ring-1 ring-black ring-opacity-5">
                        <div class="py-1">
                          <router-link :to="{name: 'studentDelete'}" class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900">
                            Delete Student
                          </router-link>
                        </div>
                      </div>
                    </div>
                  </Transition>
              </span>
            </span>
          </Toggle>
        </div>
      </div>
    </header>
    <div class="bg-white sm:shadow overflow-hidden sm:rounded-lg max-w-7xl mx-auto sm:border sm:border-cool-gray-200">
      <div class="px-4 py-5 sm:px-6">
        <dl class="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2">
          <div class="sm:col-span-2">
            <dt class="text-sm leading-5 font-medium text-gray-500">
              Name
            </dt>
            <dd class="mt-1 text-base leading-5 text-gray-900">
              {{student.first}} {{student.last}}
            </dd>
          </div>
          <div class="sm:col-span-2">
            <dt class="text-sm leading-5 font-medium text-gray-500">
              Student ID
            </dt>
            <dd class="mt-1 text-base leading-5 text-gray-900">
              {{student.schoolIdentifier}}
            </dd>
          </div>
          <div class="sm:col-span-2">
            <dt class="text-sm leading-5 font-medium text-gray-500">
              Grade Level
            </dt>
            <dd class="mt-1 text-base leading-5 text-gray-900">
              <Get :object="student" get="gradeLevel" v-slot="{ found }">
                <router-link
                  v-if="found"
                  :to="{name: 'gradeLevel', params: {gradeLevelId: found.id}}"
                  class="hover:underline"
                >
                  {{found.name}}
                </router-link>
              </Get>
            </dd>
          </div>
          <div class="sm:col-span-2">
            <dt class="text-sm leading-5 font-medium text-gray-500 mb-2">
              Home Numbers
            </dt>
            <dd class="mt-1 text-sm leading-5 text-gray-900">
              <ul class="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 cursor-pointer">
                <li
                  v-for="homeNumber in student.homeNumbers"
                  :key="homeNumber.id"
                  class="col-span-1 bg-white rounded-lg shadow border border-cool-gray-200 hover:bg-cool-gray-100 focus-within:outline-none focus-within:ring-blue focus-within:border-blue-300 focus-within:bg-cool-gray-100"
                >
                  <router-link
                    :to="{name: 'homeNumber', params: {homeNumberId: homeNumber.id}}"
                    tabindex="0"
                    class="focus:outline-none"
                  >
                    <div class="w-full flex items-center justify-between p-6 space-x-6">
                      <div class="flex-1 truncate">
                        <div class="flex items-center space-x-3">
                          <h3 class="text-base leading-5 font-medium truncate">
                            {{homeNumber.label || homeNumber.formattedNumber}}
                          </h3>
                          <Get :object="homeNumber" get="homeLanguage" v-slot="{found}">
                            <span class="flex-shrink-0 inline-block px-2 py-0.5 text-cardstock-yellow-800 text-xs leading-4 font-medium bg-cardstock-yellow-100 rounded-full" v-if="found">
                              {{found.name}}
                            </span>
                            <span class="flex-shrink-0 inline-block px-2 py-0.5 text-gray-800 text-xs leading-4 font-medium bg-gray-100 rounded-full" v-else>
                              No language set
                            </span>
                          </Get>
                        </div>
                        <p class="mt-1 text-gray-500 text-sm leading-5 truncate">
                          {{homeNumber.label ? homeNumber.formattedNumber : ''}}
                        </p>
                      </div>
                    </div>
                    <!-- <div class="border-t border-gray-200">
                      <div class="-mt-px flex">
                        <div class="w-0 flex-1 flex border-r border-gray-200">
                          <a href="#" class="relative -mr-px w-0 flex-1 inline-flex items-center justify-center py-4 text-sm leading-5 text-gray-700 font-medium border border-transparent rounded-bl-lg hover:text-gray-500 focus:outline-none focus:ring-blue focus:border-blue-300 focus:z-10 transition ease-in-out duration-150">
                            <svg class="w-5 h-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
                              <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                              <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                            </svg>
                            <span class="ml-3">Message</span>
                          </a>
                        </div>
                        <div class="-ml-px w-0 flex-1 flex">
                          <a href="#" class="relative w-0 flex-1 inline-flex items-center justify-center py-4 text-sm leading-5 text-gray-700 font-medium border border-transparent rounded-br-lg hover:text-gray-500 focus:outline-none focus:ring-blue focus:border-blue-300 focus:z-10 transition ease-in-out duration-150">
                            <svg class="w-5 h-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
                              <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                            </svg>
                            <span class="ml-3">Call</span>
                          </a>
                        </div>
                      </div>
                    </div> -->
                  </router-link>
                </li>
              </ul>
            </dd>
          </div>
          <div class="sm:col-span-2">
            <dt class="text-sm leading-5 font-medium text-gray-500 mb-2">
              Group Memberships
            </dt>
            <dd class="bg-white shadow overflow-hidden rounded-md border border-cool-gray-200">
              <ul class="rounded-md">
                <li
                  v-for="group in student.groups"
                  :key="group.id"
                  class="flex items-center justify-between text-sm leading-5"
                >
                  <router-link :to="{name: 'group', params: {groupId: group.id}}" class="block hover:bg-cool-gray-100 focus:outline-none focus:bg-gray-50 transition duration-150 ease-in-out flex-grow">
                    <div class="px-4 py-4 flex items-center sm:px-6">
                      <div class="min-w-0 flex-1 sm:flex sm:items-center sm:justify-between">
                        <div>
                          <div class="text-base leading-5 font-medium text-cardstock-blue-500 truncate">
                            {{group.name}}
                          </div>
                          <div class="mt-2 flex">
                            <div class="flex items-center text-sm leading-5 text-gray-500 mr-6">
                              <svg class="flex-shrink-0 mr-1.5 h-5 w-4 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
                                <use href="/images/regular.svg#user-circle"></use>
                              </svg>
                              <span>
                                Belongs to <TeacherNameOrYou :teacher="group.teacher" v-slot="{display}">
                                  {{display}}
                                </TeacherNameOrYou>
                              </span>
                            </div>
                            <Get :object="group" get="studentList.count" v-slot="{found}">
                              <div
                                v-if="found"
                                class="hidden md:flex items-center text-sm leading-5 text-gray-500 mr-6"
                              >
                                <svg class="flex-shrink-0 mr-1.5 h-5 w-4 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
                                  <use href="/images/regular.svg#user-graduate"></use>
                                </svg>
                                <span>
                                  {{found}} students
                                </span>
                              </div>
                            </Get>
                          </div>
                        </div>
                      </div>
                      <div class="ml-5 flex-shrink-0">
                        <svg class="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
                          <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                        </svg>
                      </div>
                    </div>
                  </router-link>
                </li>


              </ul>
            </dd>
          </div>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
import _get                   from 'lodash-es/get'
import Panel                  from '@/components/Panel.vue'
import PanelDropdown          from '@/components/PanelDropdown.vue'
import ArchivedBanner         from '@/components/ArchivedBanner.vue'
import DeletedBanner          from '@/components/DeletedBanner.vue'
import TeacherNameOrYou       from '@/snippets/TeacherNameOrYou.vue'

import Toggle                 from '@/components/Toggle'
import Get                    from '@/snippets/Get.vue'

import StudentQuery           from '@/queries/Student.gql'
import StudentArchiveMutation from '@/mutations/StudentArchive.gql'
import StudentCleanseMutation from '@/mutations/StudentCleanse.gql'
import StudentDeleteMutation  from '@/mutations/StudentDelete.gql'

import { preloadMany }        from '@/preloader'
import { tz }                 from '@/tz'

const preloadQueries = (to) => {
  return [
    {
      query: StudentQuery,
      queryName: 'student',
      variables: {
        id: to.params.studentId,
        tz: tz()
      }
    }
  ]
}

export default {
  components: {
    Panel,
    PanelDropdown,
    ArchivedBanner,
    DeletedBanner,
    TeacherNameOrYou,
    Toggle,
    Get,
  },

  props: ['currentUser', 'teamId', 'studentId'],

  beforeRouteEnter(to, from, next) {
    preloadMany({
      queries: preloadQueries(to),
      callback: next
    })
  },

  beforeRouteUpdate(to, from, next) {
    preloadMany({
      queries: preloadQueries(to),
      callback: next,
      mountedVm: this
    })
  },

  apollo: {
    student: {
      query: StudentQuery,
      variables() {
        return {
          id: this.studentId,
          tz: tz()
        }
      }
    }
  },

  computed: {
    actionsDropdownItems() {
      if ( _get(this.student, 'archivedAt') ) {
        return [
          { text: 'Edit this student', to: { name: 'studentEdit' } },
          { text: 'Un-archive it', click: this.cleanseStudent },
          { text: 'Put it in the trash', click: this.deleteStudent }
        ]
      } else if ( _get(this.student, 'deletedAt') ) {
        return [
          { text: 'Edit this student', to: { name: 'studentEdit' } },
          { text: 'Archive it', click: this.archiveStudent },
          { text: 'Un-trash it', click: this.cleanseStudent }
        ]
      } else {
        return [
          { text: 'Edit this student', to: { name: 'studentEdit' } },
          { text: 'Archive it', click: this.archiveStudent },
          { text: 'Put it in the trash', click: this.deleteStudent }
        ]
      }
    },
    first: function() {
      return _get(this.student, 'first')
    },

    gradeLevelName: function() {
      return _get(this.student, 'gradeLevel.name')
    },

    groups: function() {
      return _get(this.student, 'groups')
    },

    homeNumbers: function() {
      return _get(this.student, 'homeNumbers')
    },

    last: function() {
      return _get(this.student, 'last')
    }
  },

  methods: {
    archiveStudent() {
      this.$apollo.mutate({
        mutation: StudentArchiveMutation,
        variables: {
          id: this.studentId,
          tz: tz()
        }
      })
    },

    cleanseStudent() {
      this.$apollo.mutate({
        mutation: StudentCleanseMutation,
        variables: {
          id: this.studentId,
          tz: tz()
        }
      })
    },

    deleteStudent() {
      this.$apollo.mutate({
        mutation: StudentDeleteMutation,
        variables: {
          id: this.studentId,
          tz: tz()
        }
      })
    },

    homeNumberHeadline: function(hn) {
      return hn.label || hn.formattedNumber
    },

    homeNumberNeedsSubHeadline: function(hn) {
      return !(hn.label === null)
    }
  }

}
</script>
